<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { t } = useI18n()
const localePath = useLocalePath()

const isMobile = ref(false)
const indicator = ref<HTMLElement | null>(null)

const checkScreen = () => {
    isMobile.value = window.innerWidth < 800
}

onMounted(async () => {
    checkScreen()
    window.addEventListener('resize', checkScreen)

    if (import.meta.client) {
        gsap.registerPlugin(ScrollTrigger)

        const ctx = gsap.context(() => {
                if (indicator.value) {
                    gsap.to(indicator.value, {
                        keyframes: { y: [0, 6, 0], ease: 'power1.inOut' },
                        duration: 1.5,
                        repeat: -1
                    })
                }
            })

        ;(indicator as any)._gsapCtx = ctx
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkScreen)
    const ctx = (indicator as any)?._gsapCtx
    if (ctx) ctx.revert()
})
</script>

<template>
    <section class="relative bg-[#faefee]">
        <NuxtImg
            src="/images/home-page/home-hero-mobile.webp"
            alt="LyraGuides"
            class="md:hidden absolute inset-0 w-full h-full object-cover object-top"
            preload
            fetchpriority="high"
        />
        <NuxtImg
            src="/images/home-page/home-hero.webp"
            alt="LyraGuides"
            class="hidden md:block absolute inset-0 w-full h-full object-cover object-top"
            preload
            fetchpriority="high"
        />
        <UContainer class="relative min-h-[650px] lg:min-h-[91vh] flex flex-col justify-end pb-16 lg:pb-8">
            <div
                class="relative md:absolute md:top-[50%] md:left-0 w-full md:w-[50%] md:-translate-y-1/2 flex flex-col justify-center">
                <NuxtImg src="/images/home-page/hero-icon.svg" alt="Oznaka"
                         class="h-[50px] md:h-[116px] w-auto absolute -top-[5px] md:-top-[40px] left-0 z-4"/>
                <div class="hero-text-shape bg-[#FFF1D8] px-8 py-8 sm:px-24 sm:py-16 md:px-24 md:py-16">
                    <h1 class="uppercase text-[32px] lg:text-[46px] leading-[34px] lg:leading-[48px] text-info mb-4">{{ t("home.hero.title") }}</h1>
                    <p class="text-info mb-4" v-html="t('home.hero.description')"></p>
                    <p class="text-info mb-4"><strong>{{ t("home.hero.description_end") }}</strong></p>
                    <UButton :to="localePath('vodici')" color="primary" variant="solid" class="w-fit">{{ t("home.hero.button") }}</UButton>
                </div>
            </div>
            <div ref="indicator" class="scroll-indicator absolute left-[50%] bottom-4 -translate-x-[50px]">
                <UIcon name="lucide:chevron-down" class="!text-[40px] lg:!text-[100px] !bg-white" />
            </div>
        </UContainer>
    </section>
    <svg width="0" height="0" style="position:absolute">
        <defs>
            <clipPath id="hero-text-shape" clipPathUnits="objectBoundingBox">
                <path
                    d=" M0.134 0 L0.866 0 C0.9455 0 1.0076 0.0954 0.9993 0.205 L0.9515 0.8338 C0.9444 0.9283 0.8869 1 0.8183 1 L0.1777 1 C0.1086 1 0.0509 0.9273 0.0443 0.8322 L0.0006 0.2034 C-0.0069 0.0944 0.0549 0 0.134 0 Z"/>
            </clipPath>
        </defs>
    </svg>
</template>

<style scoped>
.hero-text-shape {
    clip-path: url(#hero-text-shape);
}
</style>
